import React from 'react';
import Loadable from 'react-loadable';
import { CircularProgress } from '@material-ui/core';
import { getSelectedGeographies, getDatapointMultiplier, getInferredChartType } from '../../../helpers';
import config from '../../../config';
import { palette } from './common';

const Chart =
  config.chartLib === 'recharts'
    ? Loadable({
        loader: () => import('./Recharts'),
        loading: () => <CircularProgress />
      })
    : Loadable({
        loader: () => import('./ChartJs'),
        loading: () => <CircularProgress />
      });

const getMetricsToChart = (metrics, selectedMetrics) => {
  let paletteIndices = { line: 0, bar: 0 };
  return selectedMetrics
    .filter(sm => sm.selected)
    .reduce((accum, selectedMetric) => {
      const metric = metrics.find(m => m.id === selectedMetric.id);
      if (!metric) return accum;
      return accum.concat(
        metric
          ? getSelectedGeographies(selectedMetric, metric.geographies)
              .filter(sg => sg.selected)
              .map(g => {
                const datapoints = metric.datapoints
                  .filter(dp => dp.geographies && dp.geographies.geographyId === g.id)
                  .reduce((map, dp) => {
                    map[dp.year] = dp.value;
                    return map;
                  }, {});

                const firstDatapoint = metric.datapoints.filter(d => d.geographies.geographyId === g.id)[0];
                const multiplier = getDatapointMultiplier(metric.datapoints, g.id)
                const multiplierSuffix = multiplier ? ` (${multiplier})` : '';
                const unitSuffix = firstDatapoint.unit && firstDatapoint.unit.trim().toLowerCase() === 'minutes' ? ' (minutes)' : '';

                const chartType = getInferredChartType(firstDatapoint.value, firstDatapoint.unit);
                const color = palette[chartType][paletteIndices[chartType]];
                paletteIndices[chartType] = (paletteIndices[chartType] + 1) % palette[chartType].length;

                return {
                  valueType: metric.valueType,
                  multiplier: multiplier,
                  unit: firstDatapoint.unit,
                  name: `${metric.name}, ${g.name}`,
                  label: `${metric.name}, ${g.name}${multiplierSuffix}${unitSuffix}`,
                  datapoints,
                  color,
                  chartType: chartType
                };
              })
          : []
      );
    }, []);
};

// the ChartDisplay component is responsible for
// - projecting the data into something that's easy to chart
// - delegating out the actual chart rendering to a component which renders it in the desired charting library

// note that we use dynamic imports so that webpack will create chunks which are loaded on-demand
// this way, we can experiment with different charting libraries without impacting the bundle size
// only the chunk containing the one library in use will be loaded
// you can change the charting library in config.js

const ChartDisplay = props => {
  const { metrics, logarithmic, stacked, fillStacked, onAnimationComplete, selectedMetrics, selectedYears, allYears } = props;
  const dataToChart = { years: selectedYears === null ? allYears : selectedYears, metrics: getMetricsToChart(metrics, selectedMetrics) };

  return (
    <Chart
      dataToChart={dataToChart}
      logarithmic={logarithmic}
      stacked={stacked}
      fillStacked={fillStacked}
      onAnimationComplete={onAnimationComplete}
    />
  );
};

export default ChartDisplay;
